import { Components, Theme } from "@mui/material/styles";

type TabsComponentOverrides = Pick<Components<Theme>, "MuiTabs" | "MuiTab">;

export const tabsComponentOverrides: TabsComponentOverrides = {
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiTabs: {},
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiTab: {
    styleOverrides: {
      root: ({ theme, color }) => ({
        display: "flex",
        flexDirection: "row",
        gap: theme.spacing(4),
        borderRadius: "2rem",
        border: 0,
        padding: theme.spacing(4, 6),
        height: "auto",
        minHeight: 0,
        color: theme.palette.text.primary,
        "&> .MuiTouchRipple-root": {
          color: color ?? theme.palette.orange.contrastText,
        },
        "&.Mui-selected": {
          backgroundColor: color ?? theme.palette.orange.contrastText,
          color: theme.palette.text.primary,
        },
      }),
    },
  },
};
